import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../shared/helper';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LogService } from './log.service';
import { Component, OnInit } from '@angular/core';
import { ILog } from '../log';
import { environment } from '../../../environments/environment';
import { LogDetailsComponent } from '../log-details/log-details.component';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {
  errorMessage: any;

  logItems: ILog[];
  loaded = false;
  paging = {
    itemsPerPage: environment.itemsPerPage,
    total: 0,
    currentPage: 1
  };
  logForm: FormGroup;
  filterProps = {};

  constructor(
    private _logService: LogService,
    private fb: FormBuilder,
    private helper: Helper,
    private _modalService: NgbModal) { }

  ngOnInit() {
    this.logForm = this.fb.group({
      ticketNumber: [''],
      flightNumber: [''],
      dateTime: [''],
      user: ['']
    });
    this.filterLog();
  }

  getPage(page: number, filterProps?: any, orderStr?: string) {
    this.loaded = false;
    if (filterProps) {
      this.filterProps = filterProps;
    }
    let params = { itemsPerPage: this.paging.itemsPerPage, page: page };
    params = Object.assign(params, this.filterProps);
    this._logService.getLogItems(params, orderStr).subscribe(res => {
      this.paging.total = Number(res.headers.get('X-total-count'));
      this.paging.currentPage = page;
      this.logItems = res.body;
      this.loaded = true;
    }, error => (this.errorMessage = <any>error));
  }

  filterLog() {
    this.helper.clearEmptyFormFilds(this.logForm.value);
    this.getPage(1, this.logForm.value, '?order[id]=DESC');
  }

  showLogDetails(log: ILog) {
    const modalRef = this._modalService.open(LogDetailsComponent, {
      size: 'lg',
      backdrop: 'static'
    });

    (<LogDetailsComponent>modalRef.componentInstance).setLog(log);
  }

}



// WEBPACK FOOTER //
// ./src/app/logs/list/logs.component.ts